export const CredTypeUnion = [
  'membership',
  'attendance',
  'certificate',
  'openbadge',
  'default',
] as const
export type CredType = typeof CredTypeUnion[number]

export type OpenBadgeInput = {
  name: string
  description: string
  criteria: string
  image: File
  achievementType?: string
  activityStartDate?: Date
  activityEndDate?: Date
  validFrom?: Date
  validUntil?: Date
}

export type DefaultInput = {
  title: string
  description?: string
  startDateInput?: Date
  endDateInput?: Date
  primaryColor: string
  link?: string
  image?: string
  tags?: string[]
  customImage?: File | null
  customImagePreview?: string
  stickerFiles?: File[] | null
  stickerPreviews?: string[]
  expirationInput?: Date
  validDuraion?: number
}

export type CredItemInput<T extends CredType> = T extends 'openbadge'
  ? OpenBadgeInput
  : DefaultInput

export type CredItemRequest = CredItemInput<'default'> & {
  stickers?: string[]
  startDate: string
  endDate: string
  collectionId: string
  credentialTypeName: string
  icon?: string
  expirationDate?: string
  organizationId?: string
}

export type OBCredItemRequest = Omit<
  OpenBadgeInput,
  'image' | 'activityStartDate' | 'activityEndDate' | 'validFrom' | 'validUntil'
> & {
  collectionId: string
  credentialTypeName: string
  image: string
  organizationId?: string
  stickers?: string[]
  activityStartDate?: string
  activityEndDate?: string
  validFrom?: string
  validUntil?: string
}
